/* eslint-disable no-unused-vars */
import { TweenMax, TimelineMax, Power2 } from 'gsap/TweenMax'
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'

// let typeOrigin = 'pc'
// let typeCurrent = ''
const animation = new TimelineMax()
    .fromTo('.system-circle-img', 0.6, { scale: 1 }, { scale: 0.032, ease: Power2.easeInOut })
    .fromTo('.sc-wrap h3', 0.6, { y: 0, opacity: 1 }, { y: -260, opacity: 0, ease: Power2.easeInOut }, '-=0.6')
    .fromTo('#dt-circle .system-circle-img', 0.1, { opacity: 1 }, { opacity: 0 })
    .fromTo('#le-circle .system-circle-img', 0.6, { x: 0 }, { x: '42%', ease: Power2.easeInOut })
    .fromTo('#dt-desc .ap-desc-line', 0.6, { scaleX: 0 }, { scaleX: 1, ease: Power2.easeInOut }, '-=0.6')
    .fromTo('.dt-ap-dot', 0.6, { scale: 0 }, { scale: 1, ease: Power2.easeInOut })
    .fromTo('#dt-desc h5', 0.6, { opacity: 0 }, { opacity: 1 })
    .fromTo('#dt-desc b', 0.6, { opacity: 0 }, { opacity: 1 }, '-=0.6')
    .fromTo('#le-desc .ap-desc-line', 0.6, { scaleX: 0 }, { scaleX: 1, ease: Power2.easeInOut })
    .fromTo('#le-circle .system-circle-img', 0.6, { x: 0 }, { x: '75%', ease: Power2.easeInOut }, '-=0.57')
    .fromTo('#dt-desc .ap-desc-anim', 0.6, { x: '60%' }, { x: '0%', ease: Power2.easeInOut }, '-=0.6')
    .fromTo('.le-ap-dot', 0.6, { scale: 0 }, { scale: 1, ease: Power2.easeInOut })
    .fromTo('#le-desc h5', 0.6, { opacity: 0 }, { opacity: 1 })
    .fromTo('#le-desc b', 0.6, { opacity: 0 }, { opacity: 1 }, '-=0.6')
    .fromTo('#lean-dash-cov', 0.6, { strokeDashoffset: 0 }, { strokeDashoffset: 1600, ease: Power2.easeInOut })
    .fromTo('.lean-dash-arr', 0.6, { opacity: 0 }, { opacity: 1, ease: Power2.easeInOut }, '-=0.6')
    .fromTo('#lean-dash', 0.6, { rotation: -40, y: '-50%' }, { rotation: 0, y: '-50%', ease: Power2.easeInOut }, '-=0.6')
    .fromTo('#acc-desc .ap-desc-line', 0.6, { scaleX: 0 }, { scaleX: 0.8, ease: Power2.easeInOut })
    .fromTo('#le-circle .system-circle-img', 0.6, { x: 0 }, { x: '84%', ease: Power2.easeInOut }, '-=0.47')
    .fromTo('#acc-desc h5', 0.6, { opacity: 0 }, { opacity: 1 })
    .fromTo('#acc-desc b', 0.6, { opacity: 0 }, { opacity: 1 }, '-=0.6')

/* eslint-disable no-new */
const controller = new ScrollMagic.Controller()

const scene = new ScrollMagic.Scene({
    triggerElement: ' #pin-sec',
    triggerHook: 'onLeave',
    duration: '360%'
})
    .setPin('#pin-sec')
    .setTween(animation)
    .addTo(controller)

export default () => {
    $(window).on('load DOMContentLoaded resize', function () {
        const windowWidth = window.innerWidth

        if (windowWidth <= 992) {
            return
        }
        controller.enabled(true)
        scene.refresh()
    })
}
